import Image from "next/image";
import UpIcon from "./images/up.svg";
import DownIcon from "./images/down.svg";
import { useState } from "react";
import { Icon as IconType } from "@/types/icon";
import Icon from "@/components/common/Icon";
import { generateLicenseLink } from "@/utils/links";

interface Props {
  icons: IconType[];
  linkTarget: string;
  multipleIcon?: IconType;
  licenseKeys: string[];
  locale: string;
  slug: string;
}

export default function MultiLicenseCell({ icons, linkTarget, multipleIcon, licenseKeys, locale, slug }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  
  // Only use icon if provided from i18n API
  if (!multipleIcon) {
    return null;
  }
  
  return (
    <button
      tabIndex={0}
      className="dropdown-container min-h-[44px] min-w-[44px]"
      onClick={() => setIsOpen(!isOpen)}
      aria-label={multipleIcon.description}
    >
      <Icon
        icon={multipleIcon}
        width={110}
        height={60}
        alt="Multiple licenses"
      />
      <Image
        className="dropdown-icon"
        src={isOpen ? UpIcon : DownIcon}
        alt=""
        tabIndex={0}
        width={20}
        height={20}
      />
      {isOpen && (
        <div className="dropdown-content">
          {icons.map((icon, index) => {
            const licenseKey = licenseKeys[index];
            const finalUrl = generateLicenseLink(licenseKey, locale, slug);
            
            return (
              <a
                key={icon.description}
                tabIndex={0}
                className="tooltip"
                href={finalUrl}
                target={finalUrl !== '#' ? linkTarget : undefined}
              >
                <Icon
                  icon={icon}
                  width={110}
                  height={60}
                  alt="License"
                />
                <span className="tooltiptext">{icon.description?.trim()}</span>
              </a>
            );
          })}
        </div>
      )}
    </button>
  );
}
